import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "24",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 23 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M8 12h6a.97.97 0 0 0 .713-.288A.96.96 0 0 0 15 11a.97.97 0 0 0-.288-.712A.97.97 0 0 0 14 10H8a.97.97 0 0 0-.712.288A.97.97 0 0 0 7 11q0 .424.288.713A.96.96 0 0 0 8 12m1 3.5h4a.97.97 0 0 0 .713-.288A.96.96 0 0 0 14 14.5a.97.97 0 0 0-.288-.712A.97.97 0 0 0 13 13.5H9a.97.97 0 0 0-.712.288A.97.97 0 0 0 8 14.5q0 .424.288.713A.96.96 0 0 0 9 15.5M6 23q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 21V3q0-.824.588-1.412A1.93 1.93 0 0 1 6 1h10q.825 0 1.413.588T18 3v3.1q.45.175.725.55T19 7.5v2q0 .475-.275.85T18 10.9V21q0 .825-.587 1.413A1.92 1.92 0 0 1 16 23zm0-2h10V3H6z"
    }, null, -1)
  ]))]))
}
export default { render: render }